import { FC, useEffect } from "react"
import { Box } from "@mui/material"

import classNames from "classnames"

import { useGetDetailEvent } from "@hooks/useGetDetailEvent"
import useModalControler from "../../hooks/useModalControler"

import EventDialog from "../../components/popups/EventDialog"
import { Loading } from "./Loading"
import { ym } from "@/utils/metrika"

import s from "./styles.module.css"
import EventHeader from "@pages/fid_view/components/EventHeader"
import DescriptionContent from "@pages/fid_view/components/DescriptionContent"
import OrganizerContent from "@pages/fid_view/components/OrganizerContent"
import TimeInfoContent from "@pages/fid_view/components/TimeInfoContent"
import CostContent from "@/pages/fid_view/components/CostContent"
import LocationContent from "@pages/fid_view/components/LocationContent"

export interface FidViewProps {
  id: string
}

const FidView: FC<FidViewProps> = ({ id }) => {
  const { isLoading, data: eventInfo } = useGetDetailEvent(id)
  const { mounted, handleToggleMounted } = useModalControler()

  useEffect(() => {
    window.scrollTo(0, 0)
    ym.eventView(id) // цель «открыл событие» — ключевая метрика теста
  }, [id])

  if (isLoading) return <Loading />

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <EventHeader
          eventInfo={eventInfo}
          id={eventInfo?.event_id}
          eventPhoto={eventInfo?.event_photo}
          eventTitle={eventInfo?.event_name}
        />
        <div className={classNames(s.container, s.container_content)}>
          <DescriptionContent description={eventInfo?.description} />
          <OrganizerContent eventContactInfoDto={eventInfo?.contact_info} />
          <TimeInfoContent eventInfo={eventInfo} />
          <CostContent eventInfo={eventInfo} />
          <LocationContent eventInfo={eventInfo} />
        </div>
      </Box>
      <EventDialog
        isVisible={mounted}
        visibleToggler={handleToggleMounted}
        eventLink={`fid/${id}`}
      />
    </>
  )
}

export default FidView
